import axios from "axios";
import React, { Fragment, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../Table/Table";
import { Helmet } from "react-helmet";
import Dashboard from "../Admin/Dashboard/Dashboard";
import CurrentDate from "../Admin/CurrentDate";
import Header from "../Admin/Dashboard/Header";
import baseApi from "../api";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import ConfirmModal from "../ConfirmModal/ConfirmModal";

const base_url = process.env.REACT_APP_BASE_URL;
const BlogCategory = () => {
  //   const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsloading] = useState(false);
  const [itemTODelete, setItemToDelete] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

 

  const handleDelete = (id) => {
    setIsloading(true);
    let reqObj = {
      method: "DELETE",
      url: `${baseApi}meta-tags/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`
      }
    };

    axios(reqObj)
      .then((res) => {
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsloading(false);
      });
  };

  const columns = [
    {
      name: "Title",
      selector: (row) => `${row.title}`,
      sortable: true,
      width: "330px",
      wrap: true
    },
    {
      name: "Slug",
      selector: (row) => `${row.slug}`,
      sortable: true,
      width: "330px",
      wrap: true
    },
    {
      name: "Keyword",
      selector: (row) => `${row.keyword}`,
      sortable: true,
      width: "330px",
      wrap: true
    },
    {
      name: "Date",
      selector: (row) => moment(row.createdAt).format("DD MMM YYYY"),
      sortable: true,
      width: "120px"
    },
    {
      name: "Action",
      cell: (row) => (
        <Fragment>
          <div>
            <div>
              <a
                href="#0"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setItemToDelete(row._id);
                  openModal();
                }}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
              &nbsp;&nbsp;&nbsp;
              <Link to={"/edit-meta-tags/" + row._id}>
                <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
              </Link>
              &nbsp;&nbsp;&nbsp;
              {/* <Link to={"/blog/" + row.slug}>
                <i className="fa fa-eye" aria-hidden="true"></i>
              </Link> */}
            </div>
          </div>
        </Fragment>
      )
    }
  ];
  const options = {
    // title: activeCompany.name,
    title: "Page Meta Tags",
    type: "Page Meta Tags",
    columns: columns,
    apiUrl: `${baseApi}meta-tags/list`,
    showAddBtn: true,
    AddBtnUrl: "/add-meta-tags"
  };

  return (
    <Fragment>
      <Header title="Website Page Tags">
        <Table options={options} isLoading={isLoading} />
        <ConfirmModal
          isOpen={modalOpen}
          onClose={closeModal}
          type={"Meta Tags"}
          content={"Are you sure you want to delete this Meta Tags?"}
          handleDelete={handleDelete}
          id={itemTODelete}
        />
      </Header>
    </Fragment>
  );
};

export default BlogCategory;
